/* eslint-disable
    @typescript-eslint/no-unused-vars,
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const AjaxQueue = require('app/scripts/network/ajax-queue');
const Auth = require('app/scripts/db/auth');
const Util = require('app/scripts/lib/util');
const Promise = require('bluebird');
const Queue = require('promise-queue');
const f = require('effing');
const { track } = require('@trello/analytics');
const xtend = require('xtend');

const queue = new Queue(3);

const methodOf = function (opts) {
  let left;
  return ((left = opts.type != null ? opts.type : opts.method) != null
    ? left
    : 'GET'
  ).toUpperCase();
};

const performAjax = function (opts) {
  if (opts.data == null) {
    opts.data = {};
  }

  // The API requires two forms of authentication (cookie + body) for non-GET
  // requests (to mitigate CSRF attacks), but does not require them for GETs.
  if (methodOf(opts) !== 'GET') {
    opts.data.token = Auth.myToken();
  }

  // But it always expects invitationTokens to be there. This is expected to
  // change in the future, so that this is consistent with token. When that
  // happens, you know what to do.
  if (!opts.suppressInvitationTokens) {
    if (opts.data.invitationTokens == null) {
      opts.data.invitationTokens = Util.invitationTokens().join(',');
    }
  }

  // If it is flagged as a background operation that the user did not start,
  // then we do not want to warn about slow sending or break on possible
  // failures.
  if (opts.background) {
    AjaxQueue.send(opts);
    return;
  }

  // Dependency required at call site to avoid import cycles, do not lift to top of module
  const ModelCache = require('app/scripts/db/model-cache');
  if (opts.modelCache == null) {
    opts.modelCache = ModelCache;
  }
  AjaxQueue.ajax(opts);
};

module.exports = (opts, next) =>
  queue
    .add(function () {
      const customSuccess = opts.success;
      const customError = opts.error;

      if (opts.headers == null) {
        opts.headers = {};
      }

      if (opts.traceId) {
        opts.headers['X-Trello-TraceId'] = opts.traceId;
      }

      return new Promise(function (resolve, reject) {
        opts = xtend(opts, {
          success(...args) {
            if (typeof customSuccess === 'function') {
              customSuccess(...Array.from(args || []));
            }
            resolve(args);
          },
          error(res, textStatus, error, fxDefault) {
            if (customError != null) {
              customError(res, textStatus, error, fxDefault);
            } else if (opts.background) {
              track('ApiAjax', 'Hidden Background Error', res.responseText);
            } else if (methodOf(opts) !== 'GET') {
              track('ApiAjax', 'Hidden Server Error', res.responseText);
            }
            reject([res, textStatus, error, fxDefault]);
          },
        });
        performAjax(opts);
      });
    })
    .nodeify(next)
    .catch(function () {})
    .done();
